var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaves({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2669 5.62184L9.59854 3.92969L8.57371 4.77576L10.2659 6.47984M21.3602 23.6278C19.9183 24.8195 18.0593 25.5464 16.0335 25.5464C13.8212 25.5464 11.6994 24.6675 10.1351 23.1032C8.57073 21.5388 7.69188 19.4171 7.69188 17.2048C7.69188 15.1789 8.4188 13.32 9.61046 11.878M5.21324 4.4421L3.69983 5.96742L5.30857 7.55233L3.96199 8.66057L5.65415 10.3527L6.97689 9.23257L7.93022 10.1859C6.23719 12.132 5.30593 14.6253 5.30857 17.2048C5.30857 20.0492 6.43851 22.7771 8.44983 24.7884C10.4611 26.7997 13.1891 27.9297 16.0335 27.9297C18.7147 27.9297 21.1695 26.9406 23.0524 25.308L25.674 27.9297L27.1874 26.4163L6.36914 5.60993L5.21324 4.4421ZM27.9501 8.52949L22.4685 3.92969L20.9312 5.75292L26.4128 10.3527L27.9501 8.52949ZM16.0335 8.86315C18.2458 8.86315 20.3675 9.742 21.9319 11.3064C23.4963 12.8707 24.3751 14.9924 24.3751 17.2048C24.3751 18.2058 24.1844 19.171 23.8627 20.0647L25.674 21.8761C26.3652 20.458 26.7584 18.885 26.7584 17.2048C26.7584 14.3603 25.6285 11.6324 23.6172 9.62109C21.6058 7.60978 18.8779 6.47984 16.0335 6.47984C14.3533 6.47984 12.7803 6.87308 11.3622 7.56425L13.1735 9.37557C14.0673 9.05382 15.0325 8.86315 16.0335 8.86315Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaves);
export default __webpack_public_path__ + "static/media/leaves.c7912b5f0445ecb5ad3aa5c4380b9f73.svg";
export { ForwardRef as ReactComponent };